import React, { useState, useEffect } from 'react';

import { Button } from '../components/Control';
import { InputText } from '../components/Input';

import { SVGArrowRight, SVGArrowRightLong } from '../components/SVG';

import Logo from '../Logo.js';

export default function SignedOut({hideModal}) {

    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emailValid, setEmailValid] = useState(false);

    const handleContinue = () => {
        if (emailValid) {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                hideModal();
            }, 1000);
        }
    }

    useEffect(() => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && emailRegex.test(email)) {
            setEmailValid(true);
        } else {
            setEmailValid(false);
        }

	}, [email]);


    return (
        <div className='flex flex-col items-center justify-center w-full h-full'>
            <Logo className='h-8 w-auto mb-20' />
            <h2 className='text-xl font-bold text-slate-900 dark:text-white'>Welcome to Swoop</h2>
            <p className='text-slate-700 dark:text-slate-300'>Please enter your email address to continue</p>
            <div className='flex flex-col gap-2 w-full mt-8'>
                <InputText type='email' value={email} setValue={setEmail} onReturn={handleContinue} placeholder='email@example.com' />
                <Button label='Continue' onClick={handleContinue} disabled={!emailValid} loading={loading} icon={SVGArrowRight} iconPosition='right' />
            </div>
        </div>
    );
}